import { Box, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { useEffect, useState } from 'react';
import { getSubscriptionData, selectLoadingState, selectSubscriptionCustomerNumber } from '../../../../redux/subscription';
import { getPendingApprovals } from '../shipmentService';
import { PendingApprovalKit } from '../types';
import Kit from './Kit';
import { addError, addSuccess } from '../../../../redux/alerts';
import LoadingSection from '../../../../components/LoadingSection';
import useCustomerNumber from '../../../../hooks/useCustomerNumber';

const PendingApprovals = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const customerNumber = useCustomerNumber()
  const subscriptionCustomerNumber = useAppSelector(selectSubscriptionCustomerNumber);
  const loadingState = useAppSelector(selectLoadingState);

  const [loading, setLoading] = useState<boolean>(true);
  const [pendingApprovals, setPendingApprovals] = useState<PendingApprovalKit[]>([]);

  const loadPendingApprovals = async () => {
    setLoading(true);

    try {
      const pending = await getPendingApprovals(customerNumber);

      setPendingApprovals(pending);
    } catch (error: any) {
      console.error(error);
      dispatch(addError(error instanceof Error ? error.message : 'Failed to load pending approvals'));
    }

    setLoading(false);
  };

  const refillSucess = () => {
    loadPendingApprovals();
    dispatch(addSuccess('Thank you for submitting your order. It is currently being processed. Please allow 2-3 weeks for delivery.'));
  };

  useEffect(() => {
    if (customerNumber) {
      loadPendingApprovals();

      if (loadingState === 'not-asked' || subscriptionCustomerNumber !== customerNumber) {
        dispatch(getSubscriptionData(customerNumber));
      }
    }
  }, [customerNumber]);

  return (
    <>
      {loading && (
        <LoadingSection />
      )}
      {!loading && (
        <Box sx={{ p: 2, color: theme.palette.color50555b.main }}>
          <div className="f-s-23 m-b-16">Pending Approvals</div>
          {pendingApprovals.length === 0 ? (
            <div className="center">There are currently no refills pending approval.</div>
          ) : (
            pendingApprovals.map((pending) => <Kit key={pending.GP_KitId} kit={pending} refresh={refillSucess} />)
          )}
        </Box>
      )}
    </>
  );
};

export default PendingApprovals;
